import type { ReceiptStatus } from '@core/db/models'

/**
 * Фискальный режим возврата (ARCH-TASK-65.10).
 *
 * Возврат наследует режим исходного чека:
 * - исходник `non_fiscal` → возврат `non_fiscal` (без ККТ и очереди);
 * - исходник фискальный (`fiscalized`/`offline_pending`) → возврат фискальный.
 *
 * Возврат «без чека» сюда не попадает: для него режим задаёт кассир
 * (по умолчанию фискальный).
 */
export type ReturnFiscalIntent = 'fiscal' | 'non_fiscal'

/** Статусы исходного чека, по которым возврат запрещён. */
export const RETURN_BLOCKED_STATUSES: ReceiptStatus[] = [
  // Чек ещё не фискализирован: возврат оформим после дофискализации.
  'offline_pending',
  'marking_review',
  'cancelled',
  'voided',
  'draft',
  'paid'
]

/** Можно ли оформить возврат по исходному чеку с таким статусом. */
export function isReturnSourceAllowed(status: ReceiptStatus): boolean {
  return !RETURN_BLOCKED_STATUSES.includes(status)
}

/** Унаследованный фискальный режим возврата. */
export function resolveReturnFiscalIntent(source: {
  status: ReceiptStatus
}): ReturnFiscalIntent {
  return source.status === 'non_fiscal' ? 'non_fiscal' : 'fiscal'
}
